export default "__VITE_ASSET__61df37ef__"